var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Listing Source"}},[_c('input-radio-multi',{attrs:{"name":"listing_source","value":_vm.listing_detail.listing_source,"options":[
            { label: 'Personal', value: 'personal' },
            { label: 'Other Broker', value: 'other_broker' },
            { label: 'Re-lo', value: 'relo' },
        ],"nullable":true,"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }